import { useState } from "react";
import Header from "./componnets/Header/Header";
import Menu from "./componnets/Menu/Menu";
import Portfolio from "./componnets/Portfolio/Portfolio";
import Profile from "./screens/profile/Profile";
import{BrowserRouter,  Route, Routes} from 'react-router-dom';

import "./app.scss";
import Project from "./componnets/Project/Project";
import Skills from "./componnets/Skills/Skills";
import Contact from "./componnets/Contact/Contact";

function App() {

  const [menuOpen,setMenuOpen] = useState(false)
  return (
    <BrowserRouter>

    <div className="App">
    <header>
    <Header  menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
    <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
    </header>

   
    <Routes>
        <Route path="/" element={<Profile/>} exact></Route>
        <Route path="/project" element={<Portfolio/>}></Route>
        <Route path="/project/:id" element={<Project/>}></Route>
        <Route path="/competence" element={<Skills/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>

        </Routes>
  
        </div>
        </BrowserRouter>
   
       
  );
}

export default App;
